interface Subcompany {
  id?: number;
  name?: string;
  companyId?: number;
}

export const newSubcompany = (): Subcompany => {
  return {};
};

export default Subcompany;
